import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { IdentityContext, IdentityProvider } from '../context';
import { useIndex } from '../hooks';

export function PowerOfAttorneyPage() {

  return (
    <IdentityProvider>
      <PowerOfAttorneyComponent />
    </IdentityProvider>
  );
}

export function PowerOfAttorneyComponent() {  
  const { person } = useContext(IdentityContext);
  const { data, loading } = useIndex('power_of_attorney', { person_id: person?.id });

  if (loading) {
    return <div>Loading power of attorney...</div>;
  }

  const powerOfAttorney = data && data[0];
  console.log(powerOfAttorney);

  // TODO: modify self path to use person id
  return (
    <div className="power-of-attorney-page">
      <h1>Power of Attorney</h1>
      {
        powerOfAttorney && powerOfAttorney.status !== 'draft' ? (
          <div>
            <h2>Power of Attorney</h2>
            <p>{powerOfAttorney.name}</p>
          </div>
        ) : (
          <div>
            <Link to="/people/self/life-documents/power-of-attorney/new">Create Power of Attorney</Link>
          </div>
        )
      }
    </div>
  );
}